var MethodType;
(function (MethodType) {
    MethodType["DEPOSIT"] = "DEPOSIT";
    MethodType["WITHDRAWAL"] = "WITHDRAWAL";
})(MethodType || (MethodType = {}));
var FeeType;
(function (FeeType) {
    FeeType["FIXED"] = "fixed";
    FeeType["PERCENTAGE"] = "percentage";
})(FeeType || (FeeType = {}));
var RedirectMethod;
(function (RedirectMethod) {
    RedirectMethod["POST"] = "post";
    RedirectMethod["GET"] = "get";
})(RedirectMethod || (RedirectMethod = {}));
var RedirectType;
(function (RedirectType) {
    RedirectType["WINDOW"] = "window";
    RedirectType["IFRAME"] = "iframe";
    RedirectType["REDIRECT"] = "redirect";
})(RedirectType || (RedirectType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["COMPLETED"] = "completed";
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["DECLINED"] = "declined";
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["CANCELLED"] = "cancelled";
})(TransactionStatus || (TransactionStatus = {}));

export { FeeType, MethodType, RedirectMethod, RedirectType, TransactionStatus };
